module.exports = __webpack_public_path__ + "img/金烽车辆管理平台(1).ffca1917.png";